var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strong',[_vm._v(_vm._s(_vm.getProductName()))]),_c('br'),_c('span',[_vm._v(_vm._s(_vm.getVariantName()))])])}
var staticRenderFns = []

export { render, staticRenderFns }